import SearchResultPagination from './SearchResultPagination.vue'

export { SearchResultPagination }
